import axios from 'utils/axiosConfig';

export const sendCampaignInvite = async ({
	restaurantID,
	campaignID,
	userID,
	firstName,
	lastName,
	isGuest,
	qrCodeStyle
}) => {
	const { data } = await axios.post(`/restaurants/${restaurantID}/campaigns/${campaignID}/invitations`, {
		user_id: userID,
		first_name: firstName,
		last_name: lastName,
		is_guest: isGuest,
		qr_code_style: qrCodeStyle
	});

	return data;
};

export const createCampaignReward = async ({
	restaurantID,
	campaignID,
	employeeID,
	deviceToken,
	name,
	quantity,
	description
}) => {
	const { data } = await axios.post(`/restaurants/${restaurantID}/campaigns/${campaignID}/rewards`, {
		name,
		description,
		quantity_available: quantity,
		employeeID,
		roleID: 2,
		deviceToken
	});

	return data;
};

export const addCampaignRewardImage = async ({
	restaurantID,
	campaignID,
	employeeID,
	rewardID,
	deviceToken,
	formData
}) => {
	formData.append('employeeID', employeeID);
	formData.append('roleID', 2);
	formData.append('deviceToken', deviceToken);

	const { data } = await axios.post(`/restaurants/${restaurantID}/campaigns/${campaignID}/rewards/${rewardID}/images`, formData);

	return data;
};
